import {AccountCircle, Ballot} from '@material-ui/icons';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {Button, Checkbox, FormControlLabel} from '@material-ui/core';
import {IInputLogin} from 'MyModels';
import {pushRoute} from '../../routes';
import {Input, PasswordInput} from '../../shared/components';
import {ButtonSubmit} from '../../shared/components/buttons';
import ButtonWhatsApp from '../../shared/components/buttons/ButtonWhatsApp';
import DetachedIcon from '../../shared/components/detachedIcon/DetachedIcon';
import HelpSection from '../election/components/HelpSection';
import Screen from '../election/screen';
import {getElection} from '../election/store/selectors';
import {loginAuthAsync} from './store/actions';
import {getInfo} from './store/selectors';

type EventHandler = React.ReactEventHandler<HTMLInputElement>;

const Login: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const election = useSelector(getElection);
  const {loading, message} = useSelector(getInfo);
  const [inputs, setInputs] = useState<IInputLogin>({
    login: '',
    password: '',
  });
  const [optIn, setOptIn] = useState<boolean>(false);
  const [shakeOptIn, setShakeOptIn] = useState(false);

  const labels = {
    login:
      election && election.configs && election.configs.input_login
        ? election.configs.input_login
        : t('autenticacao.login'),
    password:
      election && election.configs && election.configs.input_password
        ? election.configs.input_password
        : t('autenticacao.senha'),
  };

  const handleInputChange: EventHandler = ev => {
    setInputs({
      ...inputs,
      [ev.currentTarget.name]: ev.currentTarget.value,
    });
  };

  const handleChange: EventHandler = ev => {
    setOptIn(ev.currentTarget.checked);
  };

  const signIn = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (requireOptIn() && !optIn) {
      optInShake();
      return;
    } else {
      dispatch(loginAuthAsync.request(inputs));
    }
  };

  const requireOptIn = () => {
    return !!(election && election._opt_in);
  };

  const enableReceiptButton = () => {
    return !!(election && election.configs.enable_receipt_consult);
  };

  const optInShake = () => {
    setShakeOptIn(true);
    setTimeout(() => setShakeOptIn(false), 1000);
  };

  const getOptInLabel = () => {
    if (!election || !election._opt_in) {
      return '';
    }

    if (election._opt_in.file_src) {
      return (
        <div id="label-opt-in" className={shakeOptIn ? `shake` : ''}>
          <span>{election._opt_in.label} </span>
          <a href={election._opt_in.file_src} target="_blank">
            {t('autenticacao.ver-detalhes')}
          </a>
        </div>
      );
    } else {
      return (
        <div id="label-opt-in" className={shakeOptIn ? `shake` : ''}>
          <span>{election._opt_in.label} </span>
        </div>
      );
    }
  };

  if (
    election &&
    election.configs.enable_early_access === false &&
    election.status === 'pendent'
  ) {
    dispatch(pushRoute('unavailable'));
  }

  return (
    <Screen isPageAuth={true}>
      <form className="auth-form boxed-forms-300" onSubmit={signIn}>
        <DetachedIcon size="sm" icon={<AccountCircle />} />

        <h2 className="primary-title"> {t('autenticacao.entrar')} </h2>
        <p className="default-subtitle mt-0">
          {t('autenticacao.login-sub-title')}
        </p>
        <Input
          label={labels.login}
          className="full-width"
          placeholder={labels.login}
          name="login"
          type="text"
          required={true}
          autoFocus={false}
          value={inputs.login}
          onChange={handleInputChange}
        />
        <PasswordInput
          label={labels.password}
          className="full-width"
          placeholder={labels.password}
          name="password"
          hidePassword={true}
          required={true}
          value={inputs.password}
          onChange={handleInputChange}
        />

        {requireOptIn() && (
          <>
            <FormControlLabel
              className="mb-16"
              control={
                <Checkbox
                  checked={optIn}
                  onChange={handleChange}
                  name="checkedF"
                />
              }
              label={getOptInLabel()}
            />
            <br />
          </>
        )}

        {message && <p style={{color: 'red'}}>{message}</p>}

        <ButtonSubmit
          customClasses="full-width"
          loading={loading}
          classColor="green"
        />
        <HelpSection />

        {enableReceiptButton() && (
          <>
            <hr className={`full-width `} />

            <Button
              className={`full-width `}
              type="button"
              color="primary"
              onClick={() => dispatch(pushRoute('consultarComprovante'))}
              startIcon={<Ballot />}
            >
              {t('autenticacao.consultar-comprovante')}
            </Button>
          </>
        )}
      </form>
      <ButtonWhatsApp />
    </Screen>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/features/auth/Login.tsx